(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
     
	class ProductModal extends ModalDialog {
		constructor() {
          super();
        }
        hide() {
          super.hide();
          window.pauseAllMedia();
        }
        show(opener) {
          super.show(opener);
          //this.showActiveMedia();
          this.constProductPageSwiperCall()
        }
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
  let activeMediaIndex = 0;
  
  this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
    if(element.dataset.mediaId === this.openedBy.getAttribute("data-media-id")){
      activeMediaIndex = index;
    }

    // Código a ser adicionado após a definição da classe ProductModal

// Resolver problemas de clique nas imagens de produto
document.addEventListener('DOMContentLoaded', function() {
  fixProductImageClicks();
});

document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('product')) {
    setTimeout(fixProductImageClicks, 100);
  }
});

function fixProductImageClicks() {
  const mediaItems = document.querySelectorAll('.product__media-item');
  
  // Remover qualquer evento existente
  mediaItems.forEach(item => {
    const clone = item.cloneNode(true);
    if (item.parentNode) {
      item.parentNode.replaceChild(clone, item);
    }
  });
  
  // Aplicar eventos limpos
  document.querySelectorAll('.product__media-item').forEach((item, index) => {
    item.addEventListener('click', function(e) {
      // Impedir comportamento padrão
      e.preventDefault();
      e.stopPropagation();
      
      // Atualizar visualmente
      document.querySelectorAll('.product__media-item').forEach(i => {
        i.classList.remove('active');
      });
      this.classList.add('active');
      
      // Atualizar o Swiper diretamente, utilizando o índice baseado na posição do elemento no DOM
      if (window.prodPageSwiper) {
        window.prodPageSwiper.slideTo(index, 0);
      }
    });
  });
  
  // Garantir que todas as imagens sejam visíveis
  document.querySelectorAll('.product__media-item, .product__media-subitem').forEach(item => {
    item.classList.remove('hidden');
    item.style.display = '';
  });
}
  });
  
  // Destrua qualquer instância de swiper existente para evitar duplicação
  if (window.prodPageSwiper && window.prodPageSwiper.destroy) {
    window.prodPageSwiper.destroy(true, true);
  }
  
  window.prodPageSwiper = new Swiper("#featured-product-swiper", {
    zoom: true,
    centeredSlides: false,
    slidesPerView: 1,
    autoheight: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    init: false,
    navigation: {
      nextEl: ".swiper-button-next-prod-page",
      prevEl: ".swiper-button-prev-prod-page",
    },
    on: {
      slideChange: function() {
        // Obter o slide ativo
        const currentSlide = this.slides[this.activeIndex];
        
        // Verificar se tem IDs de variante associados
        if (currentSlide && currentSlide.dataset.variantIds) {
          const variantId = currentSlide.dataset.variantIds.split(',')[0];
          updateVariantFromId(variantId); // Usar a função que definimos anteriormente
        }
      }
    }
  });
  
  window.prodPageSwiper.on('init', function() {
    window.prodPageSwiper.slideTo(activeMediaIndex, 0, false);
  });
  
  window.prodPageSwiper.init();
}
    }

	// Ouvinte de evento personalizado para sincronizar variantes
	document.addEventListener('product:variant:update', function(event) {
		if (event.detail && event.detail.variantIds && event.detail.variantIds.length) {
			// Use a primeira variante da lista
			const variantId = event.detail.variantIds[0];
			
			// Encontrar e selecionar a variante correspondente nas opções disponíveis
			const variantSelectors = document.querySelectorAll('variant-radios, variant-selects');
			variantSelectors.forEach(selector => {
				const variantsScript = selector.querySelector('script');
				if (variantsScript) {
					const variants = JSON.parse(variantsScript.textContent);
					const matchingVariant = variants.find(v => v.id.toString() === variantId);
					
					if (matchingVariant) {
						// Selecionar cada opção da variante
						matchingVariant.options.forEach((optionValue, index) => {
							// Atualizar seletores de rádio (incluindo swatches de cor)
							const radioInputs = selector.querySelectorAll(`[data-index="${index}"]`);
							radioInputs.forEach(input => {
								if (input.value === optionValue) {
									input.checked = true;
									input.dispatchEvent(new Event('change', { bubbles: true }));
								}
							});
							
							// Atualizar dropdowns
							const selectInput = selector.querySelector(`select[data-index="${index}"]`);
							if (selectInput && selectInput.value !== optionValue) {
								selectInput.value = optionValue;
								selectInput.dispatchEvent(new Event('change', { bubbles: true }));
							}
						});
					}
				}
			});
		}
	});

  // Correção específica para a última imagem
  document.addEventListener('DOMContentLoaded', function() {
    function fixLastImageIssue() {
      const productImages = document.querySelectorAll('.product__media-item');
      if (!productImages.length) return;
      
      // Adiciona manipulador específico para a última imagem
      const lastImage = productImages[productImages.length - 1];
      if (lastImage) {
        lastImage.addEventListener('click', function() {
          const variantIds = this.dataset.variantIds;
          if (variantIds) {
            setTimeout(() => {
              const idArray = variantIds.split(',');
              if (idArray.length > 0) {
                const variantId = idArray[0];
                const variantScripts = document.querySelectorAll('variant-radios script, variant-selects script');
                if (variantScripts.length) {
                  try {
                    const variants = JSON.parse(variantScripts[0].textContent);
                    const matchingVariant = variants.find(v => v.id.toString() === variantId);
                    
                    if (matchingVariant) {
                      matchingVariant.options.forEach((optionValue, index) => {
                        // Para swatches de cor e outros botões de rádio
                        document.querySelectorAll(`input[type="radio"][data-index="${index}"], input[type="radio"][name*="option${index + 1}"]`).forEach(input => {
                          if (input.value === optionValue && !input.checked) {
                            input.checked = true;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                          }
                        });
                        
                        // Para selects dropdown
                        document.querySelectorAll(`select[data-index="${index}"], select[name*="option${index + 1}"]`).forEach(select => {
                          if (select.value !== optionValue) {
                            select.value = optionValue;
                            select.dispatchEvent(new Event('change', { bubbles: true }));
                          }
                        });
                      });
                    }
                  } catch (error) {
                    console.error('Erro ao processar variantes:', error);
                  }
                }
              }
            }, 50);
          }
        });
      }
    }
    
    // Execute imediatamente
    fixLastImageIssue();
    
    // Execute novamente após carregamento da seção
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail.sectionId.includes('product')) {
        setTimeout(fixLastImageIssue, 100);
      }
    });
  });

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

  // Add variant image fix script
document.addEventListener('DOMContentLoaded', function() {
  if (typeof initializeVariantImageHandling === 'function') {
    initializeVariantImageHandling();
  }
});

// Also apply when the section is loaded
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('product')) {
    if (typeof initializeVariantImageHandling === 'function') {
      setTimeout(initializeVariantImageHandling, 300);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
  	constructor() {
  		super();
  		this.elements = {
  			input: this.querySelector(
  				'input[name="locale_code"], input[name="country_code"]'
  			),
  			button: this.querySelector('button'),
  			panel: this.querySelector('ul'),
  		};
  		this.elements.button.addEventListener(
  			'click',
  			this.openSelector.bind(this)
  		);
  		this.elements.button.addEventListener(
  			'focusout',
  			this.closeSelector.bind(this)
  		);
  		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  		this.querySelectorAll('a').forEach((item) =>
  			item.addEventListener('click', this.onItemClick.bind(this))
  		);
  	}

  	hidePanel() {
  		this.elements.button.setAttribute('aria-expanded', 'false');
  		this.elements.panel.setAttribute('hidden', true);
  	}

  	onContainerKeyUp(event) {
  		if (event.code.toUpperCase() !== 'ESCAPE') return;

  		this.hidePanel();
  		this.elements.button.focus();
  	}

  	onItemClick(event) {
  		event.preventDefault();
  		this.elements.input.value = event.currentTarget.dataset.value;
  		this.querySelector('form')?.submit();
  	}

  	openSelector() {
  		this.elements.button.focus();
  		this.elements.panel.toggleAttribute('hidden');
  		this.elements.button.setAttribute(
  			'aria-expanded',
  			(
  				this.elements.button.getAttribute('aria-expanded') === 'false'
  			).toString()
  		);
  	}

  	closeSelector(event) {
  		const shouldClose =
  			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  		if (event.relatedTarget === null || shouldClose) {
  			this.hidePanel();
  		}
  	}
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}
	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
  	constructor() {
  		super();

  		const handleIntersection = (entries, observer) => {
  			if (!entries[0].isIntersecting) return;
  			observer.unobserve(this);

  			fetch(this.dataset.url)
  				.then((response) => response.text())
  				.then((text) => {
  					const html = document.createElement('div');
  					html.innerHTML = text;
  					const recommendations = html.querySelector(
  						'product-recommendations'
  					);
  					if (recommendations && recommendations.innerHTML.trim().length) {
  						this.innerHTML = recommendations.innerHTML;
  					}
  				})
  				.catch((e) => {
  					console.error(e);
  				});
  		};

  		new IntersectionObserver(handleIntersection.bind(this), {
  			rootMargin: '0px 0px 200px 0px',
  		}).observe(this);
  	}
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
